query GetDafPlanChanges($fundId: ID, $page: Int, $limit: Int) {
  dafPlanChanges(fundId: $fundId, page: $page, limit: $limit) {
    collection {
      id
      fund {
        id
        name
      }
      dateApplied
      effectiveDate
      dateCreated
      dateUpdated
      newPlan
      status
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
